import { connectRouter } from 'connected-react-router';
import { AnyAction, combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';

import storage from 'redux-persist/lib/storage';
import history from '../services/history';
import { AdherentSlice } from './AdherentRedux';
import { CompteSlice } from './CompteRedux';
import { FideliteSlice } from './FideliteRedux';
import { GlobalSlice } from './GlobalRedux';
import { ModeleCarteSlice } from './ModeleCarteRedux';
import { ProgrammeSlice } from './ProgrammeRedux';
import { ReferentielSlice } from './ReferentielRedux';

// Création du root reducer
const combinedReducer = combineReducers({
  adherent: AdherentSlice.reducer,
  programme: ProgrammeSlice.reducer,
  compte: CompteSlice.reducer,
  fidelite: FideliteSlice.reducer,
  modeleCarte: ModeleCarteSlice.reducer,
  global: GlobalSlice.reducer,
  referentiel: ReferentielSlice.reducer,
  router: connectRouter(history),
});

const rootReducer = (state, action: AnyAction) => {
  if (action.type === 'RESET') {
    //We are calling this RESET, but call what you like!
    state = {};
  }
  return combinedReducer(state, action);
};
// Export du type décrivant la structure du store Redux
export type RootState = ReturnType<typeof rootReducer>;
// Configuration de Redux Persist
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['router'],
  whitelist: ['programme', 'adherent', 'fidelite', 'global', 'modeleCarte', 'referentiel'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Création du state initial
// const initialState = {};

// // Initialisation de Saga
// const sagaMiddleware = createSagasMiddleware();

// // Création du store Redux
// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: [sagaMiddleware, routerMiddleware(history)],
//   devTools: process.env.NODE_ENV !== 'production',
//   preloadedState: initialState,
// });
// export type AppState = ReturnType<typeof rootReducer>;

// // La saga root doit être démarrée après la création du store
// sagaMiddleware.run(root);

// Export du persistor Redux Persist

export default persistedReducer;
